import api from '@/api/index'

const state = {
    current_resources_list:[],//展示资源列表
    one_index:0,
    two_index:0,
    img_index:0,
    all_list:[
        {
            "c_1":"",
            "data":[
                {
                    "c_2":"",
                    "data":[]
                }
            ]
        }
    ],
}

const mutations = {
    //选择img放进去list
    set_resources_list_vuex(state,val){
        state.all_list[state.one_index].data[state.two_index].data = val
    },
    set_all_list_vuex(state,val){
        state.all_list = val
    },
    set_one_index_vuex(state,val){
        state.one_index = val
    },
    set_two_index_vuex(state,val){
        state.two_index = val
    },
    set_img_index_vuex(state,val){
        state.img_index = val
    },
    //删除资源img
    del_img_vuex(state){
        state.all_list[state.one_index].data[state.two_index].data.splice(state.img_index,1)
    },
    //当前资源list
    set_current_resources_list_vuex(state){
        state.current_resources_list = JSON.parse(JSON.stringify(state.all_list[state.one_index].data[state.two_index].data))

        console.log(state.current_resources_list,'state.current_resources_list')
    },
    set_current_resources_list_vuex2(state,val){
        state.current_resources_list = val
    }
}

const actions = {

}

const getters = {
    current_resources_list(){
        return state.current_resources_list
    },
    all_list(){
        return state.all_list
    },
    one_index(){
        return state.one_index
    },
    two_index(){
        return state.two_index
    }
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
